import "./InfoMessage.scss";
import { useTranslation } from "react-i18next";

export default function InfoMessage({ message }) {
  const { t } = useTranslation();

  return (
    <div className="info-message-wrapper">
      <div className="check"></div>
      <div className="message">{message || t("added-to-cart")}</div>
    </div>
  );
}
